import http from '../http';
import { WASTE_API } from '@/config/env';

export const getWastes = () => http.get(`${WASTE_API}`);

export const getWastesByID = (id: number) => http.get(`${WASTE_API}/${id}`);

export const getWastesByIDFullResponse = (id: number) =>
  http.get(`${WASTE_API}/${id}`, { returnFullResponse: true });

export const getWastesByParentId = (parentId: number) =>
  http.get(`${WASTE_API}/parent/${parentId}`, { returnFullResponse: true });
export const getWastesByPath = (path: string) =>
  http.get(`${WASTE_API}/path/${path}`, { returnFullResponse: true });

export const filterWastes = async () => {
  return await http.get('/wastes/filter/c-request');
};

export const getWastesWithoutChild = () =>
  http.get(`${WASTE_API}/without-child`, { returnFullResponse: true });
